var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseImage',{staticClass:"sb-image",attrs:{"data-external":"sb-image","image-tag":"nuxt-img","src":_vm.image.url.filename,"alt":_vm.image.url.alt,"nuxt-img-config":{
    provider: 'storyblok',
    sizes: 'xs:100vw sm:100vw md:50vw lg:50vw xl:50vw',
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }